import React from "react";
import { useTranslation } from "react-i18next";
import {
  Printer,
  Smartphone,
  ScanLine,
  Wallet,
} from "lucide-react";

import i18next from "i18next";


const Hardwares = () => {
  const { t, i18n } = useTranslation();
  let lang = i18next.language;

  const hardwareItems = [
    {
      icon: <Printer size={22} />,
      title: t("Thermal Receipt Printer"),
      desc: t("80mm & 58mm Bluetooth / USB / LAN - instant pairing."),
    },
    {
      icon: <Smartphone size={22} />,
      title: t("Any Android / iOS Device"),
      desc: t("Phone or tablet, low-end to high-end. Works on 2GB RAM."),
    },
    {
      icon: <ScanLine size={22} />,
      title: t("Barcode Scanner"),
      desc: t("Wired or wireless. We auto-detect barcodes from camera too."),
    },
    {
      icon: <Wallet size={22} />,
      title: t("Cash Drawer"),
      desc: t("Auto-open on print, with daily cash reconciliation."),
    },
  ];

  return (
    <section className="py-8 md:py-16 bg-white " style={{ borderBottom: "2px gray-500" }}>
      <div className="mx-auto px-5" style={{ maxWidth: "1180px" }}>
        <div className="grid items-center gap-8 md:gap-[70px] lg:grid-cols-2">

          {/* Left Content */}
          <div>
            <h2
              className={`mb-4 text-[clamp(28px,3.6vw,44px)] font-black leading-[1.12] tracking-[-1.2px] text-gray-900 text-center ${lang === "ar" ? "md:text-right" : "md:text-left" }`}
            >
              {t("Works with the gear you already own").split(" you ")[0] + t("you")}
              <br />
              {t("Works with the gear you already own").split(" you ")[1]}
            </h2>
            <p className="text-[17px] leading-[1.7] text-gray-500">
              {t("No vendor lock-in. Use any Android phone, tablet, iPhone or PC - and pair it with the cashier hardware you have or buy a starter kit from us at cost.")}
            </p>
            <div className="mt-6">
              <div className="flex justify-center md:justify-start">
                <a
                  href="https://wa.me/201004505666?text=I%20need%20a%20hardware%20kit"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center rounded-xl bg-[#1B4597] px-7 py-4 text-[15.5px] font-bold text-white shadow-[0_2px_12px_rgba(27,69,151,0.25)] transition-all duration-300 hover:-translate-y-[1px] hover:bg-[#2557C7] hover:shadow-[0_6px_20px_rgba(27,69,151,0.4)]"
                >
                  {t("Order a Starter Kit")}
                </a>
              </div>
            </div>
          </div>

          {/* Hardware List */}
          <div className="flex flex-col gap-[14px]">
            {hardwareItems.map((item, index) => (
              <div
                key={index}
                className="flex items-center md:items-start gap-4 rounded-[20px] border-[1.5px] border-gray-200 bg-white p-2 md:p-5 transition-all duration-300 hover:border-[#1B4597] hover:shadow-[0_4px_24px_rgba(27,69,151,0.10)]"
              >
                {/* Icon */}
                <div className="grid h-[46px] w-[46px] flex-shrink-0 place-items-center rounded-[11px] text-[#1B4597] bg-[#F4F7FF]">
                  {item.icon}
                </div>

                {/* Content */}
                <div>
                  <h4 className="mb-[3px] text-[15.5px] font-extrabold tracking-[-0.1px] text-gray-900">
                    {item.title}
                  </h4>
                  <p className="text-[13.5px] leading-[1.65] text-gray-500">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hardwares;